import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import HomePage from "@/app/HomePage";

const homeSearchSchema = z.object({
  onboarding: z.string().optional(),
  next: z.string().optional(),
  error: z.string().optional(),
  feedback: z.literal("open").optional(),
});

export const Route = createFileRoute("/")({
  validateSearch: homeSearchSchema,
  component: HomePage,
});
